export default [
  {
    featureItemKey: 'response_count',
    features: ['base_response_count', 'num_free_responses'],
  },
];
